import React, { ComponentProps, FC } from 'react';
import { useFeatureFlags } from '@funtech-int/yango-shared';

import { AudioSettingPopupButtonContainer } from '../../../feature-player/ui/skin/audio-setting-popup-button/container';
import { useAudio } from '../../hooks/useAudio';
import { useSubtitles } from '../../hooks/useSubtitles';
import { useIsForcedSubtitles } from '../../hooks/useIsForcedSubtitles';
import { useSelectTrack } from '../../hooks/useSelectTrack';

type SportAudioSettingPopupButtonContainerProps = Omit<
    ComponentProps<typeof AudioSettingPopupButtonContainer>,
    'onSelectAudioTrack' | 'onSelectTextTrack' | 'audioTracks' | 'subtitles' | 'forceSubtitles'
>;

export const SportAudioSettingPopupButtonContainer: FC<
    SportAudioSettingPopupButtonContainerProps
> = ({ contentId, ...props }) => {
    const { onAudioLangChange, onSubtitlesLangChange } = useSelectTrack(contentId);
    const subtitles = useSubtitles(contentId);
    const forceSubtitles = useIsForcedSubtitles(contentId);
    const { flags } = useFeatureFlags();

    const withAudioTracksIntersection = flags.get('withAudioTracksIntersection', 'boolean', false);

    const audioTracks = useAudio(contentId);

    return (
        <AudioSettingPopupButtonContainer
            contentId={contentId}
            onSelectAudioTrack={onAudioLangChange}
            onSelectTextTrack={onSubtitlesLangChange}
            audioTracks={audioTracks}
            subtitles={subtitles}
            forceSubtitle={forceSubtitles}
            withAudioTracksIntersection={withAudioTracksIntersection}
            {...props}
        />
    );
};
